import { setUseWhatChange } from "@simbathesailor/use-what-changed";
import { isDevelopment } from "./devLogging";

setUseWhatChange(isDevelopment);
